import { useEffect, useState } from "react";
import { PageTitle } from "@components";
import { Text, Paper, Divider, Card } from "@mantine/core";

import { useDataProvider } from "@hooks";
import { TicketStatus } from "./enquiryInbox.types";
import { TicketsDataTable } from "./ticketsDataTable";
import { SearchTicketsCard } from "./searchTicketsCard";

export const PendingTickets = () => {
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState<boolean>(false);
  const [model, setModel] = useState<any>();
  const [ticketsCount, setTicketsCount] = useState<number>(0);

  useEffect(() => {}, []);

  return (
    <>
      <PageTitle
        title="Pending Tickets"
        breadcrumbs={[
          { name: "Home", route: "/dashboard" },
          { name: "Enquiry Inbox" },
          { name: "Pending Tickets" },
        ]}
        description={<Text fz="lg">{`(${ticketsCount} tickets)`}</Text>}
      />
      <SearchTicketsCard status={TicketStatus.Pending} isEscalation={false} />
      <TicketsDataTable
        tableTestId="enquiry-pendingticket-table"
        ticketStatus={TicketStatus.Pending}
        refreshTicketsCount={(i: number) => setTicketsCount(i)}
      />
    </>
  );
};
